export default "__VITE_ASSET__BALBhklf__"